import { usePageTitle } from '@global-dax-ad-platform/dax-hooks';
import { Container } from '@global-engineering-shared/gweb-material-ui';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import LoadableComponent from 'components/LoadableComponent';
import { useRefresh } from 'context/RefreshProvider/RefreshProvider';
import EntityActionBar from 'features/Entity/components/EntityActionBar';
import EntityDetailsBody from 'features/EntityDetails/components/EntityDetails/EntityDetailsBody';
import EntityDetailsHeader from 'features/EntityDetails/components/EntityDetails/EntityDetailsHeader';
import LinkedFramesDetailTableContainer from 'features/EntityDetails/components/EntityDetails/LinkedFramesDetailTable/components/LinkedFramesDetailTableContainer';
import { initialLinkedAssetDetailsState } from 'features/LinkedAssets/pages/LinkedAssetDetailsPage/utils/initialLinkedAssetDetailsState';
import useFetchData from 'hooks/useFetchData';
import { ILiveLinkedAsset } from 'types/detailsEntityType';
import { DEFAULT_TITLE, LINKED_ASSETS_API_URL, ENTITY_PAGE_URL } from 'utils/defaults';

type LinkedAssetParams = {
  linkedAssetId: string;
};

const LinkedAssetDetailsPage = () => {
  const { refreshToggle } = useRefresh();
  const { linkedAssetId } = useParams<LinkedAssetParams>();
  const { getData, isDataLoading } = useFetchData();
  const [linkedAsset, setLinkedAsset] = useState(initialLinkedAssetDetailsState);

  useEffect(() => {
    if (linkedAssetId) {
      const url = `${LINKED_ASSETS_API_URL}/${linkedAssetId}`;

      const retrieveLinkedAsset = async () => {
        await getData<ILiveLinkedAsset>(url, (response) => {
          setLinkedAsset(response);
        });
      };

      retrieveLinkedAsset();
    }
  }, [linkedAssetId, refreshToggle]);

  usePageTitle(DEFAULT_TITLE, `Linked Asset ${linkedAssetId}`);

  return (
    <main>
      <LoadableComponent loading={isDataLoading}>
        <Container maxWidth="lg">
          <EntityDetailsHeader
            entity={linkedAsset}
            linkLabel="Linked Assets"
            backLink={ENTITY_PAGE_URL}
            entityLabel="Linked Asset"
          />
          <EntityDetailsBody
            entity={linkedAsset}
            otherComponents={
              <>
                <EntityActionBar entity={linkedAsset} />
                <LinkedFramesDetailTableContainer data={linkedAsset.linkedAssetFrames} />
              </>
            }
          />
        </Container>
      </LoadableComponent>
    </main>
  );
};

export default LinkedAssetDetailsPage;
